import { useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';

interface UseDatePickerProps {
  value: Dayjs | undefined;
  onChange: (value: Dayjs | undefined) => void;
}

export function useDatePicker({ value, onChange }: UseDatePickerProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [tempDate, setTempDate] = useState<Date | undefined>();
  const [displayMonth, setDisplayMonth] = useState<Date>(new Date());

  const handleOpenChange = (open: boolean) => {
    if (open) {
      const initialDate = value?.toDate() ?? new Date();
      setTempDate(initialDate);
      setDisplayMonth(initialDate);
    }
    setIsOpen(open);
  };

  const handleConfirm = () => {
    if (tempDate) {
      onChange(dayjs(tempDate));
    }
    setIsOpen(false);
  };

  const handleDateSelect = (date: Date | undefined) => {
    if (date) {
      setTempDate(date);
    }
  };

  const handleYearMonthSelect = (year: number, month: number) => {
    setDisplayMonth(new Date(year, month - 1));
  };

  const handlePreviousMonth = () => {
    setDisplayMonth((prev) => dayjs(prev).subtract(1, 'month').toDate());
  };

  const handleNextMonth = () => {
    setDisplayMonth((prev) => dayjs(prev).add(1, 'month').toDate());
  };

  const handleTodaySelect = () => {
    const today = new Date();
    setTempDate(today);
    setDisplayMonth(today);
  };

  return {
    isOpen,
    tempDate,
    displayMonth,
    handleOpenChange,
    handleConfirm,
    handleDateSelect,
    handleYearMonthSelect,
    handlePreviousMonth,
    handleNextMonth,
    handleTodaySelect,
  };
}
